@if (leftBannerNode | async ; as item) {
  <section class="col-xs-12 global_createaccsection" id="home_flu360overview" >
    @if((item.uid === 'planning-ahead-homepage') || (item.uid ==='AboutUKBannerNewComp')){
      <div class="homepage_planningbanner" id="homepage_planningbanner">
        <div class="planningbanner_img">
          <picture>
            <source [srcset]="getImage(item.media.widescreen)" media="(min-width: 1700px)">
            <source  [srcset]="getImage(item.media.tablet)" media="(min-width: 1024px) and (max-width:1399px)">
            <img  class="flu-vaccine-image" alt="flu-vaccination" [src]="getImage(item.media.desktop)">
          </picture>
        </div>
        <div class="planningbanner_content">
          <div class="contentwrapper">
            <div class="contentHeader" [innerHTML]="item.headline"></div>
            <div class="contentsubHeader"[innerHTML]="item.h2content"></div>
          </div>
          <div class="planningbanner_btn">
            <button class="planningbanner_crtbtn"  [routerLink]="'/createprofile'">
            <span class="crtbtn_text" [innerHTML]="item.content"></span>
            <img alt="Next screen" src="../../../app/../assets/images/arrow-right-white.svg" class="crtbtn-arrow">
            </button>
        </div>
        </div>
      </div>

    }
    @if ((item.uid === 'strengthen-banner-Component') || (item.uid === 'broughtyb-banner-Component')) {
      <div >
        <div class="simple-banner banner__component--responsive">
          <img class="js-responsive-image" alt="Healthcare professional talking to older adult patient" title="Healthcare professional talking to older adult patient" [src]="getImage(item.media)">
        </div><div class="col-xs-12 home_topfirst">
        <div class="offset-lg-6 col-lg-6">
          <div [ngClass]="item.uid === 'strengthen-banner-Component' ? 'header_section1' : 'header_section2'" class="col-xs-12 global_createaccheader">{{item.headline}}</div>
          <div class="col-xs-12 global_createaccsubheader">{{item.h2content}}</div>
          <div class="col-xs-12 global_greyredbtncontainer">
            <div class="global_redbtn" [innerHTML]="item.paragraphcontent" appRouterlinkinterceptor></div>
            <div class="global_greybtn" [innerHTML]="item.content" appRouterlinkinterceptor></div>
          </div>
        </div>
      </div>
    </div>
  }
  @if ((item.uid === 'seqirus-overview-end-hero-component' || item.uid==='seqirus-ukoverview-end-hero-component')) {
    <div class="endHero" [ngClass]="{'end-hero-uk':item.uid=='seqirus-ukoverview-end-hero-component'}">
      <div class="simple-banner banner__component--responsive">
        <img class="js-responsive-image noHeight" alt="person talking to someone else" title="Healthcare professional talking to older adult patient" [src]="getImage(item.media)">
      </div>
      <div class="overview__2x2--cell">
        <div class="end-hero-callout">
          <img class="rectangle-down" src="assets/images/rectangle-down.svg">
          <p class="headLine">{{item.headline}}</p>
          <img class="rectangle-up" src="assets/images/rectangle-up.svg">
        </div>
        <a [routerLink]="'/createprofile'" [ngClass]="{'create-btn':item.uid=='seqirus-ukoverview-end-hero-component'}" class="create_account_link"><button  class="button--solid-red" type="button">
        {{"statictext.createAccount" | cxTranslate}}</button></a>
      </div>
    </div>
  }
</section>
}
<!-- removing the hardcode -->
<!-- <div class="gbr" *ngIf="leftBannerNode | async as item2">
<div *ngIf="item2.uid=='seqirus-ukoverview-end-hero-component'" class="grbno pt pb">
GBR-FLU360-23-0010 September 2024</div>
</div> -->

